export const EXPERTISE_TAXONOMY = {
  "Education & Academic Ecosystem": {
    "Academic Instruction": [
      "Professors and Faculty",
      "Adjunct and Guest Lecturers",
      "Lab Instructors",
      "Vocational and Technical Trainers"
    ],
    "Research & Mentorship": [
      "Research Guides and PhD Supervisors",
      "Industry Mentors"
    ],
    "Content & Curriculum": [
      "Course Creators",
      "Content Developers",
      "Subject Matter Experts"
    ]
  },
  "Professional Skills Trainers": {
    "Technology Trainers": [
      "AI and Data Science",
      "Cloud and Cybersecurity",
      "DevOps",
      "SAP and Salesforce"
    ],
    "Business Trainers": [
      "Sales and Marketing",
      "Finance and Procurement",
      "Operations and Supply Chain"
    ]
  },
  "Corporate Learning & Development": {
    "Leadership & Management": [
      "Leadership Development Trainers",
      "Management Development Trainers"
    ],
    "Functional & Process": [
      "Functional and Technical Trainers",
      "Product and Process Trainers"
    ],
    "Risk & Compliance": [
      "Compliance Trainers"
    ]
  },
  "Leadership & Executive Coaching": {
    "Executive & C-Suite Coaching": [
      "Executive Coaches",
      "CEO and CXO Coaches"
    ],
    "Advisory & Transformation": [
      "Board Advisors",
      "Transformation Coaches"
    ]
  },
  "Mentoring Marketplace": {
    "Business Leadership Mentors": [
      "Industry Veterans",
      "CXOs and Business Leaders"
    ],
    "Entrepreneurial Mentors": [
      "Entrepreneurs",
      "Startup Founders"
    ],
    "Academic & Alumni Mentors": [
      "Alumni Mentors"
    ]
  },
  "Agile & Transformation Experts": {
    "Agile Framework Coaching": [
      "Scrum Masters",
      "Agile and SAFe Coaches"
    ],
    "Continuous Improvement": [
      "Lean and Six Sigma Experts"
    ],
    "Strategic Transformation": [
      "Change Management Consultants",
      "Digital Transformation Advisors"
    ]
  },
  "Capstone Projects & Industry Mentors": {
    "Project Execution": [
      "Project Mentors",
      "Industry Reviewers"
    ],
    "Domain & Sponsorship": [
      "Domain Specialists",
      "Corporate Sponsors"
    ]
  },
  "Startup & Entrepreneurship Ecosystem": {
    "Product & Market Growth": [
      "Product Mentors",
      "Go-to-Market (GTM) Advisors",
      "Growth Mentors"
    ],
    "Capital & Funding": [
      "Fundraising Coaches"
    ]
  },
  "Career Development": {
    "Coaching & Counseling": [
      "Career Coaches",
      "Career Counselors"
    ],
    "Tactical Preparation": [
      "Resume Experts",
      "Interview Coaches"
    ]
  },
  "Manufacturing Excellence & Operations": {
    "Process Optimization": [
      "Lean Coaches",
      "TPM Consultants"
    ],
    "Quality, Safety & Technology": [
      "Quality Experts",
      "Safety Professionals",
      "Industry 4.0 Advisors"
    ]
  },
  "AI Coaching & Transformation": {
    "AI Strategy & Leadership": [
      "AI Adoption Consultants",
      "AI Transformation Leaders"
    ],
    "AI Implementation & Skills": [
      "Prompt Engineering Coaches",
      "AI Productivity Experts"
    ]
  },
  "Professional Services Marketplace": {
    "Strategy & Management Advisory": [
      "HR Consultants",
      "Strategy Consultants"
    ],
    "Specialized Operations Advisory": [
      "Finance Advisors",
      "Legal Advisors",
      "Supply Chain Experts"
    ]
  }
};
